import React, { useLayoutEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import usePrevious from 'utils/hooks/usePrevious';
import CollapseWrapper from './Collapse.styles';

const MAX_HEIGHT_OFFSET_PADDING = 10;

export default function Collapse({ children, isOpen }) {
    const ref = useRef(null);
    const previouslyOpen = usePrevious(isOpen);
    const [childrenHeight, setChildrenHeight] = useState(0);

    useLayoutEffect(() => {
        const componentHasChildren = ref.current && ref.current.children.length;
        const shouldCalculateHeight = !previouslyOpen && componentHasChildren;

        if (shouldCalculateHeight) {
            const childrenHeights = Array.from(ref.current.children, (childNode) => childNode.clientHeight).reduce(
                (accumulatedSum, currentElementHeight) => accumulatedSum + currentElementHeight,
                0,
            );

            setChildrenHeight(childrenHeights + MAX_HEIGHT_OFFSET_PADDING);
        }
    }, [children, ref.current]);

    return (
        <CollapseWrapper ref={ref} $childrenHeight={childrenHeight} $isOpen={isOpen}>
            {children}
        </CollapseWrapper>
    );
}

Collapse.propTypes = {
    children: PropTypes.node,
    isOpen: PropTypes.bool,
};

Collapse.defaultProps = {
    children: null,
    isOpen: false,
};
